import './Dropdown.scss'

import useOutclick from '../../../hooks/Outclick'
import { useCallback, useEffect, useRef, useState } from 'react'
import { createPortal } from 'react-dom'

const Dropdown = ({ variant = 'button', items = [], align = 'center', position = 'bottom', rightClick, children }) => {
    const [dropdownVisible, setDropdownVisible] = useState()
    const [dropdownStyles, setDropdownStyles] = useState()
    const dropdownRef = useRef(null)

    const closeDropdown = useCallback(() => {
        setDropdownVisible((prev) => prev && false)
    }, [])

    useOutclick(dropdownRef, closeDropdown)

    useEffect(() => {
        if (!dropdownVisible) {
            setDropdownStyles({})
        } else {
            const dropdownBounds = dropdownRef.current.getBoundingClientRect()
            const portalDropdownStyles = {
                minWidth: dropdownBounds.width,
            }
            switch (position) {
                case 'top': {
                    portalDropdownStyles.bottom = window.scrollY + window.innerHeight - dropdownBounds.top + 8
                    break
                }
                case 'bottom': {
                    portalDropdownStyles.top = window.scrollY + dropdownBounds.top + dropdownBounds.height + 8
                    break
                }
            }
            switch (align) {
                case 'center': {
                    portalDropdownStyles.left = dropdownBounds.left + dropdownBounds.width / 2
                    portalDropdownStyles.transform = 'translateX(-50%)'
                    break
                }
                case 'left': {
                    portalDropdownStyles.left = dropdownBounds.left
                    break
                }
                case 'right': {
                    portalDropdownStyles.right = document.body.scrollWidth - dropdownBounds.right
                    break
                }
            }
            setDropdownStyles(portalDropdownStyles)
        }
    }, [dropdownVisible])

    const onToggleRightClick = (event) => {
        event.preventDefault()
        setDropdownVisible(!dropdownVisible)
    }

    const onItemClick = (item) => {
        if (item.onClick) {
            item.onClick()
            setDropdownVisible(false)
        }
    }

    return (
        <div className="dropdown" ref={dropdownRef}>
            <button className={`toggle ${variant} ${items.length ? '' : 'empty'}`} onClick={rightClick ? null : () => setDropdownVisible(!dropdownVisible)} onContextMenu={rightClick ? onToggleRightClick : null} disabled={!items.length} >
                {children}
            </button>

            {dropdownVisible && createPortal(
                <ul className={`portal dropdown-list ${align}`} style={dropdownStyles}>
                    {items.map((item) => (
                        <li className={`item ${item.onClick && !item.disabled ? 'clickable' : 'dull'} ${item.disabled ? 'disabled' : ''}`} onClick={() => !item.disabled && onItemClick(item)} key={item.name}>{item.label || item.content}</li>
                    ))}
                </ul>, document.body
            )}
        </div>
    )
}

export default Dropdown